import { render, staticRenderFns } from "./rightMenu.vue?vue&type=template&id=62a0a34c&"
import script from "./rightMenu.vue?vue&type=script&lang=js&"
export * from "./rightMenu.vue?vue&type=script&lang=js&"
import style0 from "./rightMenu.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports